import { useEffect, useMemo, useState } from 'preact/hooks';
import { buildUrl, parseRoute, Route } from './routes';

export type NavigateOptions = {
  replace?: boolean;
};

export function navigate(route: Route, opts: NavigateOptions = {}) {
  const url = buildUrl(route);
  if (opts.replace) {
    history.replaceState(null, '', url);
  } else {
    history.pushState(null, '', url);
  }
  window.dispatchEvent(new Event('popstate'));
}

// Unified "Back" request: handled by AppShell to keep behavior deterministic across Telegram/WebView.
export function requestAppBack() {
  try {
    window.dispatchEvent(new Event('aicams-app-back'));
  } catch {}
}

export function useRoute(): Route {
  const [href, setHref] = useState(() => window.location.href);

  useEffect(() => {
    const onPop = () => setHref(window.location.href);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  return useMemo(() => parseRoute(new URL(href)), [href]);
}


